import { CALLING_GENERIC_CHANNEL_ID } from '../../generic-channels/public/constants';
export const EDITOR_CONFIG_KEYS_WITHOUT_CONFIGURATION = [CALLING_GENERIC_CHANNEL_ID];
export function isGenericChannelId(key) {
  return typeof key === 'number';
}